import React from "react";
import { Autocomplete, Checkbox, TextField, FormControl } from "@mui/material";

export const CustomMultiSelectionWithLabel = ({
  value = [],
  onChange,
  options = [],
  placeholder = "Select value",
  error,
  helperText,
  disabled = false,
  // Optional style for the option checkboxes (e.g. the teal design colour).
  checkboxSx,
}) => {
  const handleSelection = (_, selectedOptions) => {
    const labels = selectedOptions.map((item) => item.label);
    onChange(labels);
  };

  const selectedValues =
    options?.filter((opt) => value.includes(opt.label)) || [];

  return (
    <FormControl fullWidth error={!!error}>
      <Autocomplete
        multiple
        size="small"
        disabled={disabled}
        disableCloseOnSelect
        options={options}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.label === value.label}
        value={selectedValues}
        onChange={handleSelection}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox checked={selected} sx={checkboxSx} />
            {option.label}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={value.length === 0 ? placeholder : ""}
            error={!!error}
            helperText={helperText}
          />
        )}
      />
    </FormControl>
  );
};
